import React from 'react';
import { RotateCw } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';

const ABCSEServerError = ({ onRetry }) => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'abcse', feSlug: 'abc-se' });

  return (
    <ErrorPage
      Header={Header}
      Footer={Footer}
      brandAttr="ABC"
      code="500"
      title="Något gick fel"
      description="Ett oväntat fel uppstod. Försök igen eller gå till Skolmerch."
      primaryCta={{
        label: 'Försök igen',
        onClick: onRetry || (() => window.location.reload()),
        icon: <RotateCw size={20} />,
      }}
      secondaryCta={{ label: 'Till Skolmerch', onClick: () => onMenuItemClick('menu_1') }}
    />
  );
};

export default ABCSEServerError;
